import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const HabitsView = lazy(async () => {
  const m = await import("@/features/habits/components/habits-view");
  return { default: m.HabitsView };
});

/** Habit management: create, edit, reorder, archive. */
function HabitsPage() {
  return (
    <Suspense fallback={null}>
      <HabitsView />
    </Suspense>
  );
}

export const habitsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/habits",
  component: HabitsPage,
});
